import { FC } from "react";
import { IconSelectionIdentificator } from "@/components/IconSelectionIdentificator";

type IconSelectionIdentificatorBlockProps = {
  icons?: Array<{ icon: string }>;
};

export const IconSelectionIdentificatorBlock: FC<
  IconSelectionIdentificatorBlockProps
> = ({ icons = [] }) => (
  <IconSelectionIdentificator
    icons={icons.map(({ icon }) => icon).filter(Boolean)}
  />
);
